import { TTypedThunkDispatch } from '@cian/mvk-widget/es/types';
import { ITop3ReviewsContext } from '@cian/top3-reviews-widget';
import { connect } from 'react-redux';
import { Reviews } from '../../components/Reviews';

import { getNewbuildingReviewsCount } from '../../selectors/newbuilding/getNewbuildingReviewsCount';
import { IApplicationState } from '../../types/redux';
import {
  trackAnswerClick,
  trackAnswerSucceed,
  trackDislikeReview,
  trackHeaderReviewsLinkClick,
  trackLikeReview,
  trackReviewClick,
  trackReviewSucceed,
  trackSubscribed,
  trackSubscribePopupOpen,
  trackUnsubscribed,
  trackViewAllReviewsLinkClick,
  trackViewFullReviewClick,
} from './analytics/trackReviews';

interface IReviewsOwnProps {
  context?: ITop3ReviewsContext;
}

export function mapStateToProps(state: IApplicationState, { context }: IReviewsOwnProps) {
  return {
    context,
    reviewsCount: getNewbuildingReviewsCount(state),
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    onAnswerClick: () => trackAnswerClick(),
    onAnswerSucceed: (reviewId: string, answerId: string, subscribe: boolean) =>
      trackAnswerSucceed(reviewId, answerId, subscribe),
    onDislikeReview: () => trackDislikeReview(),
    onHeaderReviewsLinkClick: () => trackHeaderReviewsLinkClick(),
    onLikeReview: () => trackLikeReview(),
    onReviewClick: () => trackReviewClick(),
    // tslint:disable-next-line:variable-name
    onReviewSucceed: (_reviewId: string, subscribe: boolean) => trackReviewSucceed(_reviewId, subscribe),
    onSubscribed: () => trackSubscribed(),
    onSubscribePopupOpen: () => trackSubscribePopupOpen(),
    onUnsubscribed: () => trackUnsubscribed(),
    onViewAllReviewsLinkClick: () => trackViewAllReviewsLinkClick(),
    onViewFullReviewClick: () => trackViewFullReviewClick(),
  };
}

export const ReviewsContainer = connect(mapStateToProps, mapDispatchToProps)(Reviews);
